import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

import { InvoiceRouter } from './invoice/_router'
import { MissionInvoiceRouter } from './mission-invoice/_router'

const Index = lazy(() => import('./Index'))

export const SaleRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--sale']}>
    <Route path='*' element={<Index />} />
    <Route path='invoice/*' element={<InvoiceRouter />} />
    <Route path='mission-invoice/*' element={<MissionInvoiceRouter />} />
    <Route path='aircraft-owner-invoice/*' element={<InvoiceRouter />} />
  </SubRouter>
))
